// removed by extract-text-webpack-plugin
module.exports = {"searchorupload":"PQBhrUH-I5gHbg8pXSE2w","search":"jILftJriBMZ8hRn0Uff8_","orstatement":"_1DgAZ40GeGeWV8xgAZfObc","loadfile":"pUqt9tX4g-NWv6uIjvxlw","smallBtn":"_1le704hQo1LxqxHdZbofvF"};


//////////////////
// WEBPACK FOOTER
// ./src/views/wizard/reference/style.css
// module id = 736
// module chunks = 0